import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default PayloadMappingTable;

function PayloadMappingTable(props) {
  const { payloadMappings, onMappingEdit, onMappingDelete, addPayloadMapping, updatePayloadMapping } = props;

  if (payloadMappings.length === 0) return null;

  return (
    <Table dense>
      <TableHead>
        <TableHeader>Source</TableHeader>
        <TableHeader>Target</TableHeader>
        <TableHeader></TableHeader>
      </TableHead>
      <TableBody>
        {payloadMappings.map((item, idx) => {
          const { sourceField, targetField } = item;

          const handleItemEdit = () => onMappingEdit(item, idx);
          const handleItemDelete = () => onMappingDelete(idx);

          return (
            <TableRow key={idx}>
              <TableCell>{sourceField}</TableCell>
              <TableCell>{targetField}</TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={handleItemEdit}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={handleItemDelete}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
